import React, { useContext, useMemo } from 'react'
import objectPath from 'object-path'
import TableButton from '../TableButton'
import { DesignContext } from 'contexts/DesignContext'
import AddButton from './AddButton'
import PrintButton from './PrintButton'
import cloneDeep from 'clone-deep'

const MTableButton = (props) => {
  const designContext = useContext(DesignContext)
  const { uischema, rows } = props
  const { elementAction } = designContext

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const buttonList = {
    add: !isReadOnly ? <AddButton {...props} /> : <></>,
    print: <PrintButton {...props} />,
    selection: !isReadOnly && isEnable ? <></> : <></>,
  }

  const actionOrder = useMemo(() => {
    let tableAction = objectPath.get(uischema, 'tableAction')
    let actionOrder = objectPath.get(tableAction, 'actionOrder') || {}
    const action = tableAction?.action || []
    const printAction = action.find((item) => item.name === 'print') || {
      isActive: false,
    }
    const selectionAction = tableAction?.selection || { isActive: false }
    if (printAction?.isActive) {
      objectPath.set(actionOrder, 'print', {
        key: 'print',
        align: 'left',
        order: 0,
      })
    }
    if (selectionAction?.isActive) {
      objectPath.set(actionOrder, 'selection', {
        key: 'selection',
        align: 'right',
        order: 1,
      })
    }
    objectPath.set(actionOrder, 'add', {
      key: 'add',
      align: 'right',
      order: 2,
    })
    let orderList = Object.values(actionOrder).sort((a, b) => {
      if (a.order < b.order) return -1
      if (a.order > b.order) return 1
      return 0
    })
    return orderList
  }, [JSON.stringify(uischema?.tableAction)])

  const buttonPosition = useMemo(() => {
    let buttonPosition = []
    actionOrder.forEach((value, index) => {
      let addClassName = []
      let align = actionOrder[index]?.align
      let prev = objectPath.get(actionOrder, index - 1) || {}
      let next = objectPath.get(actionOrder, index + 1) || {}
      let prevAlign = prev?.align
      let nextAlign = next?.align

      if (align === 'left') {
        buttonPosition.push('mx-1')
      } else if (align === 'center') {
        if (prevAlign === 'center') {
          addClassName.push('ml-1')
        } else {
          addClassName.push('ml-auto')
        }
        if (nextAlign === 'center') {
          addClassName.push('mr-1')
        } else {
          addClassName.push('mr-auto')
        }
        addClassName = addClassName.join(' ')
        buttonPosition.push(addClassName)
      } else if (align === 'right') {
        if (prevAlign === 'center' || prevAlign === 'right') {
          addClassName.push('ml-1')
        } else {
          addClassName.push('ml-auto')
        }
        addClassName.push('mr-1')
        addClassName = addClassName.join(' ')
        buttonPosition.push(addClassName)
      }
    })
    return buttonPosition
  }, [JSON.stringify(uischema?.tableAction)])

  return (
    <TableButton
      {...props}
      uischema={uischema}
      actionOrder={actionOrder}
      buttonList={buttonList}
      buttonPosition={buttonPosition}
      data={cloneDeep(rows)}
    />
  )
}

export default MTableButton
